"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function bay(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M17.088 11.9805C17.1315 11.9317 17.1803 11.883 17.229 11.8335C17.3865 11.664 17.559 11.4833 17.7218 11.3085C18.3738 10.6288 18.7384 9.72365 18.7395 8.78175C18.7395 8.7165 18.75 8.448 18.75 8.40975C18.6742 6.25575 16.8607 4.5 14.7172 4.5H7.96725V7.22325H5.25V19.5H14.8253C16.953 19.5 18.75 17.6078 18.75 15.366C18.7552 13.7633 17.7645 12.6315 17.088 11.9805ZM9.32025 8.5905L14.6955 8.59575L11.3182 12.0195L14.658 15.4095H9.32025V8.5905ZM14.8253 18.1275H6.603V8.58525H7.968V16.7715H14.658C15.21 16.7715 15.7028 16.4377 15.9135 15.924C16.0173 15.674 16.0449 15.3989 15.9928 15.1332C15.9408 14.8675 15.8114 14.6232 15.621 14.4307L13.2345 12.0135L15.6593 9.558C16.0492 9.16425 16.1625 8.57925 15.9517 8.0655C15.8505 7.81523 15.6769 7.60087 15.4531 7.44989C15.2293 7.2989 14.9655 7.21816 14.6955 7.218H9.3255V5.862H14.7225C16.152 5.862 17.3535 7.02675 17.4022 8.44275C17.4022 8.50275 17.391 8.73825 17.391 8.7435V8.7705C17.3909 9.36436 17.1602 9.93498 16.7475 10.362C16.5795 10.5375 16.4062 10.7227 16.2495 10.887C15.984 11.166 15.7568 11.4067 15.648 11.5162L15.1605 11.997L15.6427 12.4845C15.708 12.5498 15.789 12.6262 15.8865 12.7192C16.449 13.2442 17.397 14.1187 17.397 15.3547C17.4022 16.8315 16.2008 18.1275 14.8253 18.1275Z", fill: color }));
}
exports["default"] = bay;
//# sourceMappingURL=bay.js.map